/* ========= KEUTEK CUSTOM JS ========= */

/* ================= iPad / touch nav =================
   Phones keep the drawer (CSS ≤768). iPad/desktop widths show the inline
   menu. Motion's hoverMenu() binds click→navigate + mouseleave-close on
   details[data-hover=true] BEFORE we can flip the attribute, so iPad taps
   never reach submenu links. Clone details to drop those listeners and use
   native <details> open/close on tap.
*/
(function () {
  function needsTouchNavFix() {
    var ua = navigator.userAgent || "";
    var iOS = /iPad|iPhone|iPod/.test(ua);
    var iPadOS = ua.indexOf("Macintosh") !== -1 && navigator.maxTouchPoints > 1;
    var coarse = window.matchMedia("(pointer: coarse)").matches;
    var noHover = window.matchMedia("(hover: none)").matches;
    return iOS || iPadOS || (coarse && noHover);
  }

  if (!needsTouchNavFix()) return;

  document.documentElement.classList.add("keutek-touch-nav");

  var outsideBound = false;

  function bindOutsideClose() {
    if (outsideBound) return;
    outsideBound = true;

    document.addEventListener(
      "click",
      function (evt) {
        document
          .querySelectorAll('[data-section-type="header"] details.site-nav__details[open]')
          .forEach(function (detail) {
            if (detail.contains(evt.target)) return;
            detail.removeAttribute("open");
            var summary = detail.querySelector("summary");
            if (summary) summary.setAttribute("aria-expanded", "false");
          });
      },
      true
    );
  }

  function neutralizeHoverMenus() {
    document
      .querySelectorAll('[data-section-type="header"] details.site-nav__details')
      .forEach(function (detail) {
        detail.setAttribute("data-hover", "false");

        // Already cleaned (and not replaced again by theme.js)
        if (detail.getAttribute("data-keutek-touch-nav") === "1") return;

        var clean = detail.cloneNode(true);
        clean.setAttribute("data-hover", "false");
        clean.setAttribute("data-keutek-touch-nav", "1");
        // Drop open state copied from a hover-stuck menu
        clean.removeAttribute("open");
        var summary = clean.querySelector("summary");
        if (summary) summary.setAttribute("aria-expanded", "false");

        if (detail.parentNode) {
          detail.parentNode.replaceChild(clean, detail);
        }
      });

    bindOutsideClose();
  }

  function run() {
    neutralizeHoverMenus();
    // theme HeaderSection.init often runs in the same DOMContentLoaded turn
    setTimeout(neutralizeHoverMenus, 0);
    setTimeout(neutralizeHoverMenus, 300);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }
  document.addEventListener("shopify:section:load", function () {
    setTimeout(neutralizeHoverMenus, 0);
  });
})();

/* ================= Sticky header spacer sync =================
   Motion sets #StickyHeaderWrap height once from #SiteHeader.offsetHeight.
   Logo/fonts/nav CSS often grow the header a moment later, so the wrap stays
   short and the overflowing header clips the secondary nav circles.

   Important: while the header is stuck it uses tighter padding, so measuring
   then would shrink the spacer and pull secondary nav up over the logo.
*/
(function () {
  var restingHeight = 0;
  var scheduled = false;

  function isHeaderStuck(header) {
    return header.classList.contains("site-header--stuck");
  }

  function measureHeaderHeight(header) {
    var box = header.getBoundingClientRect();
    var bottom = box.bottom;

    // Logo images are position:absolute inside a padding-top aspect box. If the
    // logo column width collapses, that box is 0x0 and offsetHeight ignores the
    // visible logo — include overflowing logo bottoms explicitly.
    var imgs = header.querySelectorAll(".site-header__logo img, .header-item--logo img");
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (getComputedStyle(img).display === "none") continue;
      var ib = img.getBoundingClientRect();
      if (ib.height > 0) bottom = Math.max(bottom, ib.bottom);
    }

    var layout = header.querySelector(".header-layout");
    if (layout) bottom = Math.max(bottom, layout.getBoundingClientRect().bottom);

    return Math.ceil(Math.max(bottom - box.top, header.offsetHeight || 0));
  }

  function syncStickyHeaderWrap() {
    var header = document.getElementById("SiteHeader");
    var wrap = document.getElementById("StickyHeaderWrap");
    if (!header || !wrap) return;

    // Never shrink/replace the spacer from the stuck (compact) header size.
    if (isHeaderStuck(header)) {
      if (restingHeight > 0 && wrap.style.height !== restingHeight + "px") {
        wrap.style.height = restingHeight + "px";
      }
      return;
    }

    var height = measureHeaderHeight(header);
    if (!height) return;

    if (!restingHeight) {
      restingHeight = height;
    } else if (height > restingHeight) {
      restingHeight = height;
    } else if (height < restingHeight - 8) {
      // Real shrink only (e.g. touch-nav hid a desktop nav row), ignore subpixels.
      restingHeight = height;
    }

    if (wrap.style.height !== restingHeight + "px") {
      wrap.style.height = restingHeight + "px";
    }
  }

  function clearErroneousStickyTop() {
    // Motion treats the next header-group section as an announcement bar and
    // writes its height onto .header-wrapper top. Secondary nav is next, so
    // that value is wrong — clear it.
    var header = document.getElementById("SiteHeader");
    if (!header) return;
    var section = header.closest(".shopify-section");
    var next = section && section.nextElementSibling;
    if (!next || !next.querySelector(".keutek-secondary-nav")) return;
    var hw = document.querySelector(".header-wrapper");
    if (hw && hw.style.top) hw.style.top = "";
  }

  function scheduleSync() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      clearErroneousStickyTop();
      syncStickyHeaderWrap();
    });
  }

  function boot() {
    clearErroneousStickyTop();
    syncStickyHeaderWrap();
    scheduleSync();

    window.addEventListener("load", scheduleSync, { passive: true });
    window.addEventListener("resize", function () {
      restingHeight = 0;
      scheduleSync();
    }, { passive: true });
    window.addEventListener("orientationchange", function () {
      restingHeight = 0;
      scheduleSync();
    }, { passive: true });
    document.addEventListener("shopify:section:load", function () {
      restingHeight = 0;
      setTimeout(scheduleSync, 50);
      setTimeout(scheduleSync, 300);
    });

    [100, 300, 800, 1600].forEach(function (ms) {
      setTimeout(scheduleSync, ms);
    });

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(scheduleSync).catch(function () {});
    }

    var header = document.getElementById("SiteHeader");
    if (header && typeof ResizeObserver !== "undefined") {
      var ro = new ResizeObserver(scheduleSync);
      ro.observe(header);
    }

    var logo = header && header.querySelector("img");
    if (logo && !logo.complete) {
      logo.addEventListener("load", scheduleSync, { once: true });
    }

    document.addEventListener("keutek:layout", scheduleSync);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();

/* ================= Secondary nav collapse (no persistence) ================= */
(function () {
  var LABEL_HIDE = "Collapse Category Menu";
  var LABEL_SHOW = "Expand Category Menu";

  function setCollapsed(nav, collapsed) {
    var toggle = nav.querySelector(".keutek-secondary-nav__toggle");
    var label = nav.querySelector(".keutek-secondary-nav__toggle-label");
    nav.classList.toggle("is-collapsed", collapsed);
    if (toggle) toggle.setAttribute("aria-expanded", collapsed ? "false" : "true");
    if (label) label.textContent = collapsed ? LABEL_SHOW : LABEL_HIDE;
    document.dispatchEvent(new CustomEvent("keutek:layout"));
  }

  function bind(nav) {
    if (!nav || nav.dataset.keutekNavBound === "1") return;
    nav.dataset.keutekNavBound = "1";
    var toggle = nav.querySelector(".keutek-secondary-nav__toggle");
    if (!toggle) return;

    toggle.addEventListener("click", function () {
      setCollapsed(nav, !nav.classList.contains("is-collapsed"));
    });
  }

  function init() {
    document.querySelectorAll("[data-keutek-secondary-nav]").forEach(bind);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
  document.addEventListener("shopify:section:load", function () {
    setTimeout(init, 50);
  });
})();

/* ================= KEUTEK Discount Badge (Variant JSON driven, no observers) ================= */

(function () {
  if (window.KEUTEK_DISABLE_DISCOUNT_BADGE) return;

  function fmtMoneyFromCents(cents) {
    // Match Shopify money formatting style like $14.00
    const n = cents / 100;
    return "$" + n.toFixed(2);
  }

  function getVariants() {
    const el = document.querySelector("textarea[data-variant-json]");
    if (!el) return null;
    try {
      return JSON.parse(el.value || el.textContent || "[]");
    } catch (e) {
      console.warn("KEUTEK badge: unable to parse variants JSON", e);
      return null;
    }
  }

  function getSelectedVariantId() {
    // Motion updates this on variant selection
    const idInput = document.querySelector('form[action^="/cart/add"] [name="id"], form[id^="AddToCartForm"] [name="id"]');
    if (idInput && idInput.value) return Number(idInput.value);
    return null;
  }

  function computeAndPaint() {
    const roots = document.querySelectorAll("[data-keutek-discount]");
    if (!roots.length) return;

    const variants = getVariants();
    if (!variants || !variants.length) return;

    const vid = getSelectedVariantId();
    const v = variants.find(x => Number(x.id) === Number(vid)) || variants.find(x => x.available) || variants[0];
    if (!v) return;

    const price = Number(v.price || 0);                 // cents
    const compare = Number(v.compare_at_price || 0);    // cents

    roots.forEach((root) => {
      const badgeEl = root.querySelector("[data-keutek-badge]");
      const saveEl = root.querySelector("[data-keutek-save]");
      if (!badgeEl || !saveEl) return;

      // Not on sale -> hide
      if (!compare || compare <= price) {
        root.style.setProperty("display", "none", "important");
        return;
      }

      const savings = compare - price;
      const pct = Math.round((savings * 100) / compare);

      const mode = root.getAttribute("data-mode") || "percent_save";

      if (mode === "bundle") {
        badgeEl.textContent = `BUNDLE & SAVE ${fmtMoneyFromCents(savings)}`;
        saveEl.style.display = "none";
        saveEl.textContent = "";
      } else if (mode === "amount") {
        badgeEl.textContent = `${fmtMoneyFromCents(savings)} OFF TODAY`;
        saveEl.style.display = "none";
        saveEl.textContent = "";
      } else {
        badgeEl.textContent = `${pct}% OFF TODAY`;
        saveEl.textContent = `(Save ${fmtMoneyFromCents(savings)})`;
        saveEl.style.display = "";
      }

      root.style.setProperty("display", "flex", "important");
    });
  }

  // Schedule updates lightly (no observers)
  let raf = false;
  function schedule() {
    if (raf) return;
    raf = true;
    requestAnimationFrame(() => {
      raf = false;
      computeAndPaint();
    });
    // Motion sometimes updates id input slightly after click
    setTimeout(computeAndPaint, 120);
  }

  function boot() {
    // First paint
    computeAndPaint();

    // Update when variant changes (hidden input "id" updates)
    document.addEventListener("change", (e) => {
      if (e.target && e.target.name === "id") schedule();
      if (e.target && e.target.matches("[data-variant-input], select")) schedule();
    });

    document.addEventListener("click", (e) => {
      if (e.target.closest(".variant-input") || e.target.closest("[data-variant-input]")) schedule();
    });

    // Theme editor reload
    document.addEventListener("shopify:section:load", () => setTimeout(computeAndPaint, 50));
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();

/* ================= Quantity discount tiles (ICTQD tags) ================= */
(function () {
  function money(cents) {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    }).format((cents || 0) / 100);
  }

  function perUnit(basePriceCents, qty, discountCents) {
    var total = basePriceCents * qty - discountCents;
    return Math.round(Math.max(total, 0) / qty);
  }

  function initQd(root) {
    if (!root || root.dataset.keutekQdReady === "1") return;
    var grid = root.parentElement && root.parentElement.querySelector("[data-keutek-qd-grid]");
    if (!grid) return;

    var variants = [];
    var variantsEl = root.querySelector("[data-keutek-qd-variants]");
    try {
      variants = JSON.parse((variantsEl && variantsEl.textContent) || "[]");
    } catch (e) {
      variants = [];
    }

    var rules = [];
    try {
      rules = JSON.parse(root.getAttribute("data-qd") || "[]");
    } catch (e) {
      rules = [];
    }
    if (!rules.length) return;
    rules.sort(function (a, b) {
      return a.qty - b.qty;
    });

    root.dataset.keutekQdReady = "1";

    function getVariantId() {
      var input = document.querySelector('[name="id"]');
      return (input && input.value) || root.dataset.fallbackVariantId;
    }

    function getVariantPriceCents(variantId) {
      var v = variants.find(function (x) {
        return String(x.id) === String(variantId);
      });
      if (v && v.price != null) return parseInt(v.price, 10);
      return parseInt(root.dataset.basePriceCents || "0", 10);
    }

    function addToCart(qty) {
      var id = getVariantId();
      if (!id) return;
      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({ id: id, quantity: qty }),
      }).then(function () {
        location.href = "/cart";
      });
    }

    function render() {
      var basePriceCents = getVariantPriceCents(getVariantId());
      var first = rules[0];
      var last = rules[rules.length - 1];
      grid.innerHTML =
        '<div class="keutek-qd-grid">' +
        '<div class="keutek-qd-tile" data-qty="' +
        first.qty +
        '"><div class="qd-title">Buy ' +
        first.qty +
        '</div><div class="qd-price"><span class="qd-price-red">' +
        money(perUnit(basePriceCents, first.qty, first.discount_cents)) +
        '</span><span class="qd-ea">/ea</span></div></div>' +
        '<div class="keutek-qd-tile" data-qty="' +
        last.qty +
        '"><div class="qd-title">Buy ' +
        last.qty +
        '+</div><div class="qd-price"><span class="qd-price-red">' +
        money(perUnit(basePriceCents, last.qty, last.discount_cents)) +
        '</span><span class="qd-ea">/ea</span></div></div>' +
        "</div>";
    }

    render();

    document.addEventListener("change", function (e) {
      if (e.target && e.target.matches('[name="id"]')) render();
    });

    var idInput = document.querySelector('[name="id"]');
    if (idInput) {
      var obs = new MutationObserver(render);
      obs.observe(idInput, { attributes: true, attributeFilter: ["value"] });
    }

    grid.addEventListener("click", function (e) {
      var tile = e.target.closest(".keutek-qd-tile");
      if (!tile) return;
      addToCart(parseInt(tile.dataset.qty, 10));
    });
  }

  function boot() {
    document.querySelectorAll("[data-keutek-qd]").forEach(initQd);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
  document.addEventListener("shopify:section:load", boot);
})();

/* ================= Collection grid: recover + manual sort =================
   Variant-scoped collection members are often omitted from Liquid
   collection.products (they still appear in products.json). On Default
   templates they disappear; on keutek-variants they get appended and break
   manual sort. Sync the grid to products.json order and inject any missing
   products as normal cards (Default) when Liquid did not output them.
*/
(function () {
  function collectionSortBy() {
    try {
      return new URLSearchParams(window.location.search).get("sort_by") || "";
    } catch (e) {
      return "";
    }
  }

  function collectionHandleFromPath() {
    var match = (window.location.pathname || "").match(/\/collections\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : "";
  }

  function cardHandle(card) {
    return (
      card.getAttribute("data-product-handle") ||
      (card.querySelector &&
        card.querySelector("[data-product-handle]") &&
        card.querySelector("[data-product-handle]").getAttribute("data-product-handle")) ||
      ""
    );
  }

  function formatMoney(cents) {
    try {
      if (window.theme && theme.Currency && theme.Currency.formatMoney && theme.settings) {
        return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
      }
    } catch (e) {}
    return "$" + (Number(cents || 0) / 100).toFixed(2);
  }

  function gridItemClass(grid) {
    var sample = grid.querySelector(".grid-product");
    if (!sample) return "grid__item grid-product small--one-half medium-up--one-quarter";
    var copy = sample.className
      .split(/\s+/)
      .filter(function (c) {
        return c && c !== "grid-product__has-quick-shop";
      })
      .join(" ");
    return copy || "grid__item grid-product small--one-half medium-up--one-quarter";
  }

  function buildProductCard(product, className) {
    var img =
      product.featured_image ||
      (product.images && product.images[0]) ||
      "";
    if (img && img.indexOf("//") === 0) img = "https:" + img;
    var price = formatMoney(product.price);
    var compare =
      product.compare_at_price && product.compare_at_price > product.price
        ? formatMoney(product.compare_at_price)
        : "";
    if (product.handle === "keutek-port-cover-replacement-service") {
      if (product.price_varies && product.price_min && product.price_max) {
        price =
          "Return shipping " +
          formatMoney(product.price_min) +
          "–" +
          formatMoney(product.price_max);
      } else {
        price = "Return shipping " + (product.price_varies ? "from " : "") + price;
      }
    }
    var url = product.url || "/products/" + product.handle;

    var el = document.createElement("div");
    el.className = className;
    el.setAttribute("data-product-handle", product.handle);
    el.setAttribute("data-product-id", String(product.id));
    el.setAttribute("data-keutek-recovered", "1");
    el.innerHTML =
      '<div class="grid-product__content">' +
      '<a href="' +
      url +
      '" class="grid-product__link">' +
      '<div class="grid-product__image-mask"><div class="image-wrap">' +
      (img
        ? '<img class="grid-product__image" src="' +
          img +
          '" alt="" loading="lazy" width="400" height="400">'
        : "") +
      "</div></div>" +
      '<div class="grid-product__meta">' +
      '<div class="grid-product__title">' +
      (product.title || "") +
      "</div>" +
      '<div class="grid-product__price">' +
      (compare
        ? '<span class="grid-product__price--original">' + compare + "</span> "
        : "") +
      "<span>" +
      price +
      "</span></div>" +
      "</div></a></div>";
    return el;
  }

  function markSortReady(grid) {
    if (grid) grid.setAttribute("data-keutek-sort-ready", "1");
  }

  function reorderGrid(grid, order) {
    var cards = Array.prototype.slice.call(grid.children).filter(function (el) {
      return el.nodeType === 1 && (el.classList.contains("grid-product") || el.classList.contains("grid__item"));
    });
    if (!cards.length) return;

    var groups = Object.create(null);
    var seen = [];
    cards.forEach(function (card) {
      var h = cardHandle(card);
      if (!h) {
        seen.push({ handle: "", cards: [card] });
        return;
      }
      if (!groups[h]) {
        groups[h] = [];
        seen.push({ handle: h, cards: groups[h] });
      }
      groups[h].push(card);
    });

    var frag = document.createDocumentFragment();
    var placed = Object.create(null);

    order.forEach(function (h) {
      if (!groups[h] || placed[h]) return;
      groups[h].forEach(function (card) {
        frag.appendChild(card);
      });
      placed[h] = true;
    });

    seen.forEach(function (group) {
      if (group.handle && placed[group.handle]) return;
      group.cards.forEach(function (card) {
        frag.appendChild(card);
      });
      if (group.handle) placed[group.handle] = true;
    });

    grid.appendChild(frag);
  }

  function syncCollectionRoot(root) {
    if (!root) return;
    // Manual Collection card blocks define order — do not regroup by product.
    if (root.getAttribute("data-keutek-manual-cards") === "true") {
      var manualGrid = root.querySelector(".product-grid-container");
      if (manualGrid) {
        manualGrid.setAttribute("data-keutek-sort-applied", "1");
        manualGrid.setAttribute("data-keutek-sort-ready", "1");
      }
      return;
    }
    var handle = root.getAttribute("data-collection-handle") || collectionHandleFromPath();
    var grid = root.querySelector(".product-grid-container");
    if (!handle || !grid) return;
    if (grid.getAttribute("data-keutek-sort-applied") === "1") {
      markSortReady(grid);
      return;
    }

    var sortBy = collectionSortBy();
    if (sortBy && sortBy !== "manual") {
      markSortReady(grid);
      return;
    }

    var isVariantTemplate = root.classList.contains("keutek-collection-variants");
    var done = false;

    function finish(ok) {
      if (done) return;
      done = true;
      if (ok) grid.setAttribute("data-keutek-sort-applied", "1");
      markSortReady(grid);
    }

    setTimeout(function () {
      finish(false);
    }, 2500);

    fetch("/collections/" + encodeURIComponent(handle) + "/products.json?limit=250")
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .then(function (data) {
        if (!data || !data.products || !grid.isConnected) {
          finish(false);
          return Promise.resolve();
        }

        var order = data.products.map(function (p) {
          return p.handle;
        });
        var existing = {};
        grid.querySelectorAll("[data-product-handle]").forEach(function (el) {
          existing[el.getAttribute("data-product-handle")] = true;
        });

        var missing = order.filter(function (h) {
          return h && !existing[h];
        });

        // On keutek-variants, Liquid recovers selected products as variant cards.
        // Only inject plain product cards on Default / other templates.
        var inject = !isVariantTemplate ? missing : [];

        var className = gridItemClass(grid);
        return Promise.all(
          inject.map(function (h) {
            return fetch("/products/" + encodeURIComponent(h) + ".js")
              .then(function (res) {
                return res.ok ? res.json() : null;
              })
              .then(function (product) {
                if (!product || !product.handle) return;
                grid.appendChild(buildProductCard(product, className));
              })
              .catch(function () {});
          })
        ).then(function () {
          reorderGrid(grid, order);
          finish(true);
        });
      })
      .catch(function () {
        finish(false);
      });
  }

  function bootKeutekCollectionSync() {
    document
      .querySelectorAll("#CollectionSection[data-collection-handle], .keutek-collection-variants[data-collection-handle]")
      .forEach(syncCollectionRoot);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bootKeutekCollectionSync);
  } else {
    bootKeutekCollectionSync();
  }
  document.addEventListener("shopify:section:load", function () {
    document.querySelectorAll(".product-grid-container[data-keutek-sort-applied]").forEach(function (grid) {
      grid.removeAttribute("data-keutek-sort-applied");
      grid.removeAttribute("data-keutek-sort-ready");
    });
    bootKeutekCollectionSync();
  });
})();

/* ================= Magnetic tip finder ================= */
(function () {
  var MODELS = {
    apple: {
      "iPhone SE / 6 / 7 / 8 / X / 11 / 12 / 13 / 14": "Lightning iOS",
      "iPhone 15 and newer (USB-C)": "Type-C",
      "iPad (before 2020)": "Lightning iOS",
      "iPad (2020 and later)": "Type-C",
    },
    samsung: {
      "Galaxy S7 or earlier": "Micro USB",
      "Galaxy S8 and later": "Type-C",
    },
    google: { "Pixel 1–8": "Type-C" },
    motorola: {
      "Older models (pre-2018)": "Micro USB",
      "Newer models (2018+)": "Type-C",
    },
    other: { "Bluetooth speakers / cameras": "Micro USB" },
  };

  var TIPS = {
    "Lightning iOS":
      "You need <strong>Lightning iOS Tips</strong> — for iPhones and older iPads.",
    "Type-C": "You need <strong>Type-C Tips</strong> — for newer Androids and USB-C iPads.",
    "Micro USB":
      "You need <strong>Micro-USB Tips</strong> — for older Androids, cameras, and accessories.",
  };

  function initFinder(root) {
    if (!root || root.dataset.keutekTipReady === "1") return;
    var toggle = root.querySelector(".find-my-tip-toggle");
    var content = root.querySelector(".find-my-tip-content");
    var brand = root.querySelector("[data-tip-brand]");
    var model = root.querySelector("[data-tip-model]");
    var result = root.querySelector("[data-tip-result]");
    if (!toggle || !content || !brand || !model || !result) return;

    root.dataset.keutekTipReady = "1";
    toggle.setAttribute("aria-expanded", "false");
    content.hidden = true;

    toggle.addEventListener("click", function () {
      var open = toggle.getAttribute("aria-expanded") === "true";
      toggle.setAttribute("aria-expanded", String(!open));
      content.hidden = open;
    });

    brand.addEventListener("change", function () {
      var selected = brand.value;
      model.innerHTML = '<option value="">-- Select Model --</option>';
      result.innerHTML = "";
      if (selected && MODELS[selected]) {
        Object.keys(MODELS[selected]).forEach(function (label) {
          var opt = document.createElement("option");
          opt.textContent = label;
          opt.value = MODELS[selected][label];
          model.appendChild(opt);
        });
        model.disabled = false;
      } else {
        model.disabled = true;
      }
    });

    model.addEventListener("change", function () {
      var tipType = model.value;
      result.innerHTML = TIPS[tipType] || "";

      document
        .querySelectorAll('input[data-variant-input][name="Charging Tip"]')
        .forEach(function (r) {
          if (r.value.trim().toLowerCase() === tipType.toLowerCase()) {
            r.checked = true;
            r.dispatchEvent(new Event("change", { bubbles: true }));
          }
        });

      var addBtn = document.querySelector('button[name="add"], .add-to-cart');
      if (addBtn) addBtn.scrollIntoView({ behavior: "smooth", block: "center" });
    });
  }

  function boot() {
    document.querySelectorAll("[data-keutek-tip-finder]").forEach(initFinder);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
  document.addEventListener("shopify:section:load", boot);
})();

/* Port cover service: collection/search cards say "From $X" — label as return shipping */
(function () {
  var HANDLE = "keutek-port-cover-replacement-service";

  function relabel(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-product-handle="' + HANDLE + '"] .grid-product__price').forEach(function (el) {
      if (el.getAttribute("data-keutek-return-shipping")) return;
      var text = (el.textContent || "").replace(/\s+/g, " ").trim();
      if (!text || /return shipping/i.test(text)) {
        el.setAttribute("data-keutek-return-shipping", "1");
        return;
      }
      el.setAttribute("data-keutek-return-shipping", "1");
      if (/^from\s+/i.test(text)) {
        el.textContent = text.replace(/^from\s+/i, "Return shipping from ");
      } else {
        el.textContent = "Return shipping " + text;
      }
    });
  }

  function bootRelabel(evt) {
    relabel(evt && evt.target);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", bootRelabel);
  else bootRelabel();
  document.addEventListener("shopify:section:load", bootRelabel);
})();

/* SEO landing: variant price/availability + ATC.
 *
 * DO NOT OVERRIDE — same rules for every keutek-seo-landing page:
 * Pre-order → replace ATC with a PDP <a> (no .add-to-cart class, no cart/add).
 * In stock → Motion AjaxProduct / cart drawer.
 * Keep the primary button visible. Edit this IIFE + sections/keutek-seo-landing.liquid only.
 */
(function () {
  function money(cents) {
    if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === "function" && theme.settings && theme.settings.moneyFormat) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }
    return new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format((cents || 0) / 100);
  }

  function selectedOptions(form) {
    var opts = [];
    form.querySelectorAll("fieldset").forEach(function (fs) {
      var checked = fs.querySelector("input[type=radio]:checked");
      if (checked) opts.push(checked.value);
    });
    return opts;
  }

  function matchVariant(variants, options) {
    if (!variants || !variants.length) return null;
    if (!options.length) return variants[0];
    return (
      variants.find(function (v) {
        return options.every(function (opt, i) {
          return v.options[i] === opt;
        });
      }) || null
    );
  }

  function timesactPreorder(productId, variantId) {
    try {
      var store = (window.ta && window.ta.products) || {};
      function fromVariant(v) {
        if (!v) return null;
        if ("isPOEnabled" in v) return !!v.isPOEnabled;
        if (v.config && (v.config.status === "ACTIVE" || v.config.status === "NO_STOCK")) return true;
        return false;
      }
      var rec = store[String(productId)] || store[productId];
      if (rec && rec.variants) {
        var direct = fromVariant(rec.variants[String(variantId)] || rec.variants[variantId]);
        if (direct !== null) return direct;
      }
      var key;
      for (key in store) {
        if (!store[key] || !store[key].variants) continue;
        var found = fromVariant(store[key].variants[String(variantId)] || store[key].variants[variantId]);
        if (found === true) return true;
      }
    } catch (e) {}
    return null;
  }

  function isPreorder(form, variant) {
    if (form.getAttribute("data-keutek-seo-preorder-product") === "true") return true;
    if (!variant) return false;
    if (form.querySelector("#preorder-label, .timesact-preorder-description")) return true;
    var ta = timesactPreorder(form.getAttribute("data-keutek-seo-product-id"), variant.id);
    if (ta === true) return true;
    if (ta === false) return false;
    var qty = variant.inventory_quantity;
    var policy = variant.inventory_policy;
    if (policy === "continue" && typeof qty === "number" && qty <= 0) return true;
    return false;
  }

  function bindForm(form) {
    if (form.getAttribute("data-keutek-seo-bound")) return;
    form.setAttribute("data-keutek-seo-bound", "1");

    var jsonEl = form.parentElement && form.parentElement.querySelector("[data-keutek-seo-variants]");
    var variants = [];
    try {
      variants = jsonEl ? JSON.parse(jsonEl.textContent) : [];
    } catch (e) {
      variants = [];
    }

    var productUrl = form.getAttribute("data-keutek-seo-product-url") || "";
    var idInput = form.querySelector('input[name="id"]');
    var priceEl = form.parentElement.querySelector("[data-keutek-seo-price]");
    var availEl = form.parentElement.querySelector("[data-keutek-seo-avail]");
    var btn = form.querySelector(".add-to-cart, .keutek-seo-lp__atc");
    var btnText = form.querySelector(".add-to-cart__text");
    var ajaxBound = false;
    var pdpLocked = false;

    function currentVariant() {
      return matchVariant(variants, selectedOptions(form));
    }

    function pdpUrl(variant) {
      var url = productUrl;
      if (!url) return "";
      if (variant && variant.id) {
        url += (url.indexOf("?") === -1 ? "?" : "&") + "variant=" + encodeURIComponent(variant.id);
      }
      return url;
    }

    function goToProduct(variant) {
      var url = pdpUrl(variant);
      if (url) window.location.href = url;
    }

    /* Replace submit/ATC with a plain PDP link so iCart/AjaxProduct cannot cart-add. */
    function lockToPdp(variant) {
      var url = pdpUrl(variant);
      if (!url) return;
      pdpLocked = true;
      var current = form.querySelector(".keutek-seo-lp__atc");
      if (current && current.tagName === "A") {
        current.setAttribute("href", url);
        current.textContent = "Buy on product page";
        current.classList.remove("add-to-cart");
        return;
      }
      var link = document.createElement("a");
      link.className = "btn keutek-seo-lp__atc keutek-seo-lp__atc--pdp";
      link.setAttribute("href", url);
      link.textContent = "Buy on product page";
      if (current) current.replaceWith(link);
      else form.appendChild(link);
      btn = link;
      btnText = null;
    }

    function sync() {
      var variant = currentVariant();
      if (!variant || !idInput) return;
      idInput.value = variant.id;
      var preorder = isPreorder(form, variant);
      var canBuy = variant.available || preorder;
      if (priceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceEl.innerHTML =
            '<span class="visually-hidden">Sale price</span>' +
            '<span class="keutek-seo-lp__price-sale">' +
            money(variant.price) +
            "</span> <s class=\"keutek-seo-lp__price-compare\">" +
            money(variant.compare_at_price) +
            "</s>";
        } else {
          priceEl.innerHTML = "<span>" + money(variant.price) + "</span>";
        }
      }
      if (availEl) {
        availEl.textContent = !canBuy ? "Sold out" : preorder ? "Pre-order" : "In stock";
      }
      if (preorder) {
        lockToPdp(variant);
      } else if (btn && btn.tagName === "BUTTON") {
        btn.disabled = !canBuy;
        if (btnText) btnText.textContent = !canBuy ? "Sold out" : "Add to Cart";
      }
      document.querySelectorAll("[data-keutek-seo-hero-cta]").forEach(function (el) {
        if (!canBuy) {
          el.textContent = "Sold out";
          el.setAttribute("href", pdpUrl(variant) || "#buy");
          el.setAttribute("aria-disabled", "true");
          return;
        }
        el.removeAttribute("aria-disabled");
        if (preorder) {
          el.textContent = "Buy on product page";
          el.setAttribute("href", pdpUrl(variant));
        } else {
          el.textContent = "Add to Cart";
          el.setAttribute("href", "#buy");
        }
      });
    }

    form.addEventListener(
      "submit",
      function (evt) {
        var variant = currentVariant();
        if (pdpLocked || isPreorder(form, variant) || timesactPreorder(form.getAttribute("data-keutek-seo-product-id"), variant && variant.id) === true) {
          evt.preventDefault();
          evt.stopImmediatePropagation();
          goToProduct(variant);
        }
      },
      true
    );

    form.addEventListener(
      "click",
      function (evt) {
        var t = evt.target.closest(".add-to-cart, .keutek-seo-lp__atc");
        if (!t) return;
        var variant = currentVariant();
        if (pdpLocked || isPreorder(form, variant)) {
          evt.preventDefault();
          evt.stopImmediatePropagation();
          if (t.tagName === "A" && t.getAttribute("href")) {
            window.location.href = t.getAttribute("href");
            return;
          }
          goToProduct(variant);
        }
      },
      true
    );

    form.addEventListener("change", sync);
    sync();

    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      sync();
      var variant = currentVariant();
      var ta = variant ? timesactPreorder(form.getAttribute("data-keutek-seo-product-id"), variant.id) : null;
      var ready = ta !== null || tries > 25;
      if (!ready) return;
      clearInterval(timer);
      if (pdpLocked || isPreorder(form, variant) || ta === true) {
        lockToPdp(variant);
        return;
      }
      if (!ajaxBound && window.theme && typeof theme.AjaxProduct === "function") {
        ajaxBound = true;
        new theme.AjaxProduct(form);
      }
    }, 400);
  }

  function bindHeroCtas() {
    document.querySelectorAll("[data-keutek-seo-hero-cta]").forEach(function (el) {
      if (el.getAttribute("data-keutek-seo-hero-bound")) return;
      el.setAttribute("data-keutek-seo-hero-bound", "1");
      el.addEventListener("click", function (evt) {
        var form = document.querySelector("[data-keutek-seo-atc]");
        if (!form) return;
        var jsonEl = form.parentElement && form.parentElement.querySelector("[data-keutek-seo-variants]");
        var variants = [];
        try {
          variants = jsonEl ? JSON.parse(jsonEl.textContent) : [];
        } catch (e) {
          variants = [];
        }
        var variant = matchVariant(variants, selectedOptions(form));
        if (!variant) return;
        if (isPreorder(form, variant) || timesactPreorder(form.getAttribute("data-keutek-seo-product-id"), variant.id) === true) {
          evt.preventDefault();
          var url = form.getAttribute("data-keutek-seo-product-url") || el.getAttribute("href");
          if (variant.id) {
            url += (url.indexOf("?") === -1 ? "?" : "&") + "variant=" + encodeURIComponent(variant.id);
          }
          window.location.href = url;
          return;
        }
        evt.preventDefault();
        if (typeof form.requestSubmit === "function") form.requestSubmit();
        else form.dispatchEvent(new Event("submit", { cancelable: true, bubbles: true }));
      });
    });
  }

  function boot() {
    document.querySelectorAll("[data-keutek-seo-atc]").forEach(bindForm);
    bindHeroCtas();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
  document.addEventListener("shopify:section:load", boot);
})();
/* ================= iCart accessibility softeners =================
   iCart injects cart drawer markup we do not own. Patch common Lighthouse
   failures when nodes appear: unlabeled selects, bare aria-label on divs,
   empty-cart images without alt, and out-of-order cart headings.
*/
(function () {
  function demoteIcartHeading(h) {
    if (!h || h.getAttribute("data-keutek-a11y") === "1") return;
    var p = document.createElement("p");
    p.className = h.className || "";
    p.setAttribute("data-keutek-a11y", "1");
    if (h.getAttribute("style")) p.setAttribute("style", h.getAttribute("style"));
    while (h.firstChild) p.appendChild(h.firstChild);
    h.parentNode.replaceChild(p, h);
  }

  function fixIcartA11y(root) {
    root = root || document;

    root.querySelectorAll(".keutek-icart-payments[aria-label], .keutek-product-payments[aria-label]").forEach(function (el) {
      if (!el.getAttribute("role")) el.setAttribute("role", "group");
    });

    root.querySelectorAll(".icart-cart-empty-contain img:not([alt]), .icart img.fr-fil:not([alt]), .icart img.fr-dib:not([alt])").forEach(function (img) {
      img.setAttribute("alt", "");
    });

    root.querySelectorAll("select.icart-variants-box").forEach(function (sel) {
      if (sel.getAttribute("aria-label") || sel.getAttribute("aria-labelledby")) return;
      if (sel.id && root.querySelector('label[for="' + sel.id + '"]')) return;
      sel.setAttribute("aria-label", "Product variant");
    });

    root.querySelectorAll(".icart-content-title h1, .icart-content-title h2, .icart-content-title h3, .icart-content-title h4, .icart-content-title h5, .icart-content-title h6").forEach(demoteIcartHeading);
  }

  function boot() {
    fixIcartA11y(document);
    if (window.__keutekIcartA11yObs) return;
    window.__keutekIcartA11yObs = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var nodes = mutations[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          var n = nodes[j];
          if (n.nodeType !== 1) continue;
          if (
            (n.matches && n.matches(".icart, [class*='icart']")) ||
            (n.querySelector && n.querySelector(".icart, select.icart-variants-box, .keutek-icart-payments, .icart-content-title"))
          ) {
            fixIcartA11y(n);
          }
        }
      }
    });
    window.__keutekIcartA11yObs.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
